import React from 'react'
import ArticleDetailHeadInfos from '@/elements/widgets/Article/ArticleDetailHead/Infos/ArticleDetailHeadInfos'
import ArticleDetailHeadIntro from '@/elements/widgets/Article/ArticleDetailHead/Intro/ArticleDetailHeadIntro'

export type ArticleHeadProps = {
  readonly items: Array<{
    readonly id: string
    readonly model: {
      readonly publishedAt: string
      readonly lastmodifiedAt: string
      readonly republishing: boolean
      readonly kicker: string
      readonly headline: string
      readonly ad: string
      readonly author?: {
        readonly authorRender?: string
        readonly name?: string
        readonly url?: string
        readonly link?: string
        readonly image?: {
          readonly heightRatio: number
          readonly filename: string
          readonly baseUrl: string
          readonly crop: string
        }
      }
      readonly audio: {
        readonly homeSection: string
        readonly id: string
        readonly kicker: string
        readonly headline: string
        readonly duration: string
        readonly urls: {
          readonly mp3: string
        }
      }
    }
  }>
  readonly model: any
}

export const showRepublishingHint = (republishing: boolean, publishedAt: string, lastmodifiedAt: string) => {
  if (republishing && new Date(lastmodifiedAt).getTime() - new Date(publishedAt).getTime() > 24 * 60 * 60 * 1000)
    return true
  return false
}

export default function ArticleHead({
  item,
}: Readonly<{
  item: ArticleHeadProps
}>) {
  if (item?.model?.fields?.variant === 'infos') {
    return <ArticleDetailHeadInfos item={item} />
  }

  return <ArticleDetailHeadIntro item={item} />
}
